import React from 'react';
import bem from '../../../../lib/bemUtils/bem';
import { Modifier } from '../../../../lib/bemUtils/Modifier';
import { SVG, SVGIcon } from '../../../../components/atoms/SVG';

export enum StatusInfoIconModifier {
  GREEN = 'green',
  MARGIN_RIGHT = 'margin-right',
}

export function StatusInfoIcon({ icon, modifier }: { icon: SVGIcon; modifier?: Modifier<StatusInfoIconModifier> }) {
  return (
    <span className={bem('status-info__icon', modifier)} aria-hidden="true">
      <SVG svgSpriteId={icon} />
    </span>
  );
}
